// extracted by mini-css-extract-plugin
export default {"root":"style_root__a1Iew","attention":"style_attention__OkGDa","count":"style_count__OCnOU","label":"style_label__ee4ZV","hint":"style_hint__ic3d8","arrow":"style_arrow__JmWIo"};